import { FunctionField, useRecordContext } from "react-admin";
import {
  DateFieldMod,
  EmailFieldMod,
  TextFieldMod,
} from "../../../../../Component/Layouts/Field";
import StatusField from "../../../../../Component/Layouts/Field/StatusField";
import { Status } from "../../../Constant/Status";
import { TabMod } from "../../../../../Component/Redesign/Show";
import OnDutyField from "../../../../../Component/Layouts/Field/OnDutyField";
import { Boolean } from "../../../Constant/Boolean";
import { useCategoryChoices } from "../../../Constant/Category";
import { useTypeChoices } from "../../../Constant/Type";
import { makePhotoSource } from "utils/constants";

const InformationTab = () => {
  const record = useRecordContext();

  const categories = useCategoryChoices();
  const types = useTypeChoices();

  return (
      <div className="information-tab-content">
          <TabMod>
              <TextFieldMod source="firstName" />
              <TextFieldMod source="lastName" />
              <TextFieldMod source="description" />
              <EmailFieldMod source="email" />
              <TextFieldMod source="phone" />
              {record.photo && (
                <>
                  <div
                    style={{
                      fontSize: "12px",
                      marginBottom: "3px",
                      opacity: "0.6",
                      fontFamily: "Roboto",
                      color: "black",
                    }}
                  >
                    Photo
                  </div>
                  <img
                    src={makePhotoSource(record.photo.source)}
                    alt="avatar"
                    style={{ width: "60px", height: "60px" }}
                  />
                </>
              )}
              <StatusField
                source="status"
                statusList={Status}
                style={{ minWidth: "60px" }}
              />
              {record.role === "ROLE_DOCTOR" ? (
                <OnDutyField
                  label="resources.admins.fields.isOnDuty"
                  list={Boolean}
                  style={{ minWidth: "60px" }}
                />
              ) : null}
              {record.role === "ROLE_DOCTOR" ? (
                <FunctionField
                  label="resources.admins.fields.category"
                  source="category"
                  render={(record) =>
                    `${categories.find((el) => el.id === record.category).name}`
                  }
                />
              ) : null}
              {record.role === "ROLE_DOCTOR" ? (
                <FunctionField
                  label="Type"
                  source="type"
                  render={(record) =>
                    `${types.find((el) => el.id === record.type).name}`
                  }
                />
              ) : null}
              <DateFieldMod
                source="createdAt"
                options={{ day: "2-digit", month: "2-digit", year: "numeric" }}
              />
            </TabMod>
      </div>
  );
};

export default InformationTab;
